import { SiteContryEnum } from "shared/enums/globalEnums";

export const isFrance = (value: SiteContryEnum): boolean => value === SiteContryEnum.France;
